<template>
  <div>
    <!-- Search筛选 -->
    <el-form :inline="true" :model="params" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="params.id" placeholder="Id" clearable style="width:100px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="params.card_number" placeholder="Number" clearable style="width:140px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-cascader :options="country_business" size="small"
          :props="{ checkStrictly: true,value:'name',label:'name',expandTrigger: 'hover'}" clearable
          placeholder="Country/Business" @change="cascaderChange" style="position:relative;right:2px">
        </el-cascader>
      </el-form-item>
      <el-select size="small" v-model="params.callback_state" clearable placeholder="Callback Status"
        style="width:140px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in callback_state_list" :key="item.k" :label="item.v" :value="item.k">
        </el-option>
      </el-select>
      <el-select size="small" v-model="params.trans_type" clearable placeholder="Type"
        style="width:100px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in trans_type_list" :key="item.k" :label="item.v" :value="item.k">
        </el-option>
      </el-select>
      <el-select size="small" v-model="params.fee_type" clearable placeholder="Fee"
        style="width:100px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in fee_type_list" :key="item.k" :label="item.v" :value="item.k">
        </el-option>
      </el-select>
      <el-select size="small" v-model="params.flag" clearable placeholder="Tag"
        style="width:140px;position:relative;top: 5px;right:5px">
        <el-option v-for="item in flag_list" :key="item.k" :label="item.v" :value="item.k">
        </el-option>
      </el-select>
      <el-form-item label="">
        <el-input size="small" v-model="params.amount" placeholder="Amount" clearable style="width:100px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="params.transaction_id" placeholder="Transaction Id" clearable
          style="width:140px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="params.body" placeholder="Body" clearable style="width:140px">
        </el-input>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker v-model="params.trans_time" type="daterange" size="small" value-format="yyyy-MM-dd"
          align="right" unlink-panels start-placeholder="Start date(trans time)" end-placeholder="End date(trans time)"
          :picker-options="pickerOptions" clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker v-model="params.callback_time" type="daterange" size="small" value-format="yyyy-MM-dd"
          align="right" unlink-panels start-placeholder="Start date(callback)" end-placeholder="End date(callback)"
          :picker-options="pickerOptions" clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
        <el-button type="success" size="small" icon="el-icon-document" @click="exportExcel">Export</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" element-loading-text="Loading..."
      style="width: 100%;">
      <el-table-column prop="id" label="Id" width="80" align="center">
      </el-table-column>
      <el-table-column prop="card_number" label="Number" width="110">
        <template slot-scope="scope">
          <div>{{scope.row.card_number}}</div>
          <div>{{scope.row.opencard_name}}&nbsp;&nbsp;{{scope.row.operator_name}}</div>
          <div>{{scope.row.sms_user_name}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="transaction_id" label="Transaction Id" width="110">
        <template slot-scope="scope">
          <div>{{scope.row.transaction_id}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="Amount/Fee" width="100">
        <template slot-scope="scope">
          <div>{{scope.row.amount}}</div>
          <div v-if="scope.row.fee>0">{{scope.row.fee}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="balance" label="Balance/Balance Diff" width="100">
        <template slot-scope="scope">
          <div>{{scope.row.balance}}</div>
          <el-link type="danger" :underline="false" v-if="scope.row.balance_diff!=0">{{scope.row.balance_diff}}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="user_phone" label="User/Business/Tran ID" width="120">
        <template slot-scope="scope">
          <div>{{scope.row.user_phone}}</div>
          <div>{{scope.row.business_name}}</div>
          <div v-if="scope.row.trans_id!='0'">{{scope.row.trans_id}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="body" label="Body">
        <template slot-scope="scope">
          <div>{{scope.row.body}}<span v-if="scope.row.create_man"
              style="color:#F56C6C">({{scope.row.create_man}})</span>
          </div>
          <div style="color:#F56C6C" v-if="scope.row.create_sms">
            {{scope.row.create_sms.body}}({{scope.row.create_sms.create_man}})</div>
          <div v-if="scope.row.app_name">
            <el-link type="primary" @click="seeMessage(scope.row.file_url)">{{scope.row.app_name}}</el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="add_time" label="Time" width="180">
        <template slot-scope="scope">
          <div><span style="color:#909399">trans：</span>{{scope.row.trans_time|timestampToTime}}</div>
          <div><span style="color:#909399">sms：</span>{{scope.row.sms_time|timestampToTime}}</div>
          <div><span style="color:#909399">add：</span>{{scope.row.save_time|timestampToTime}}</div>
          <div><span style="color:#909399">callback：</span>{{scope.row.callback_time|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="trans_type" label="Type" width="140" align="center">
        <template slot-scope="scope">
          <el-link type="primary" :underline="false" v-if="scope.row.trans_type==1">Recharge</el-link>
          <el-link type="warning" :underline="false" v-if="scope.row.trans_type==2">Withdraw</el-link>
          <el-link type="danger" :underline="false" v-if="scope.row.trans_type==3">Recharge refund</el-link>
          <el-link type="danger" :underline="false" v-if="scope.row.trans_type==4">Withdraw refund</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="callback_state" label="Callback Status" width="130" align="center">
        <template slot-scope="scope">
          <el-link type="danger" icon="el-icon-edit"
            @click="setFlag(scope.row.id,scope.row.flag,scope.row.flag_business)" :underline="false"
            v-if="scope.row.callback_state==0">Pending
          </el-link>
          <el-link type="danger" icon="el-icon-edit"
            @click="setFlag(scope.row.id,scope.row.flag,scope.row.flag_business)" :underline="false"
            v-if="scope.row.callback_state==3">Match failed
          </el-link>
          <el-link type="warning" :underline="false" v-if="scope.row.callback_state==2">Failed
          </el-link>
          <div v-if="scope.row.flag" style="color:#909399">{{scope.row.flag|flagstate}}</div>
          <div v-if="scope.row.flag==1" style="color:#909399">{{scope.row.flag_business}}</div>
          <el-link type="success" :underline="false" v-if="scope.row.callback_state==1">Success
          </el-link>
          <el-link type="info" :underline="false" v-if="scope.row.callback_state==4">Abnormal
          </el-link>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Action" width="140">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" v-if="scope.row.flag==0&&scope.row.business_id>0"
            @click="messageCallback(scope.row)">
            Callback Details</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- Callback Details -->
    <el-dialog title="" :visible.sync="callbackVisible" @click='closeDialog("callback")' width="50%">
      <el-descriptions title="Callback Details" :column="2" border style="padding-bottom:20px">
        <el-descriptions-item :labelStyle="{width:'140px'}" label="Callback URL" span="2">{{messageInfo.callback_url}}
        </el-descriptions-item>
        <el-descriptions-item :labelStyle="{width:'140px'}" label="Callback nums">{{messageInfo.error_num}}
        </el-descriptions-item>
        <el-descriptions-item :labelStyle="{width:'140px'}" label="Callback Status">
          <el-link type="danger" :underline="false" v-if="messageInfo.callback_state==0">Pending
          </el-link>
          <el-link type="danger" :underline="false" v-if="messageInfo.callback_state==2">Failed
          </el-link>
          <el-link type="success" :underline="false" v-if="messageInfo.callback_state==1">Success
          </el-link>
        </el-descriptions-item>
        <el-descriptions-item :labelStyle="{width:'140px'}" label="Callback Datas" :column="2">{
          "card_number": "{{messageInfo.card_number}}",
          "amount": "{{messageInfo.amount}}",
          "currency": "{{messageInfo.currency}}",
          "fee": {{messageInfo.fee}},
          "user_phone": "{{messageInfo.user_phone}}",
          "transaction_id": "{{messageInfo.transaction_id}}",
          "country": "{{messageInfo.country}}",
          "address": "{{messageInfo.address}}",
          "trans_type": {{messageInfo.trans_type}},
          "body": "{{messageInfo.body}}",
          "trans_time": {{messageInfo.trans_time}},
          "sms_time": {{messageInfo.sms_time}}
          }</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
  import {
    smsListNewBackups,
    messageCallback,
    transBusinessList,
    countryList,
    getCountryBusiness
  } from '../../api/apiFun'
  import {
    timestampToTime,
    exportUrl,
    getCookie,
    cascaderChange,
  } from '@/utils/util';
  import Pagination from '../../components/Pagination'
  let that = ""
  export default {
    data() {
      return {
        dkh_user: getCookie('dkh_user'),
        loading: false, //是显示加载
        examineVisible: false, //控制Edit页面显示与隐藏
        params: {
          page: 1,
          limit: 10,
          id: '',
          card_number: '',
          amount: '',
          transaction_id: '',
          callback_time: '',
          trans_time: '',
          save_time: '',
          trans_type: '',
          callback_state: '',
          body: '',
          fee_type: '',
          flag: '',
          business_name: '',
          country: ''
        },
        trans_type_list: [{
            k: 1,
            v: 'Recharge'
          },
          {
            k: 2,
            v: 'Withdraw'
          },
          {
            k: 3,
            v: 'Recharge refund'
          },
          {
            k: 4,
            v: 'Withdraw refund'
          },
        ],
        fee_type_list: [{
            k: 1,
            v: 'equal to 0'
          },
          {
            k: 2,
            v: 'not equal to 0'
          }
        ],
        callback_state_list: [{
            k: 0,
            v: 'Pending'
          },
          {
            k: '1',
            v: 'Success'
          },
          {
            k: '2',
            v: 'Failed'
          },
          {
            k: '1,2',
            v: 'Success/Failed'
          }
        ],
        flag_list: [{
            k: 1,
            v: 'Business withdrawal'
          },
          {
            k: 2,
            v: 'Our withdrawal'
          },
          {
            k: 3,
            v: 'kaka'
          },
          {
            k: 4,
            v: 'Withdraw repeat'
          },
          {
            k: 5,
            v: 'Withdraw wrong'
          },
          {
            k: 6,
            v: 'Withdraw complement'
          },
          {
            k: 7,
            v: 'Test'
          },
          {
            k: 8,
            v: 'Others'
          },
          {
            k: 9,
            v: 'Unlock fee'
          },
          {
            k: 10,
            v: 'Refund'
          },
          {
            k: 11,
            v: 'SMS delay'
          },
        ],
        listData: [], //User数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        pickerOptions: {
          shortcuts: [{
            text: 'Today',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last week',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        business_list: [],
        callbackVisible: false,
        messageInfo: {},
        countryList: [],
        country_business: []
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    filters: {
      timestampToTime: function (timestamp) {
        return timestampToTime(timestamp)
      },
      smsListNewBackupsstate: function (i) {
        var v = '';
        that.state_list.forEach(e => {
          if (e.k == i) {
            v = e.v
          }
        });
        return v
      },
      flagstate: function (i) {
        var v = '';
        that.flag_list.forEach(e => {
          if (e.k == i) {
            v = e.v
          }
        });
        return v
      },
      transtypestate: function (i) {
        var v = '';
        that.trans_type_list.forEach(e => {
          if (e.k == i) {
            v = e.v
          }
        });
        return v
      },
    },
    created() {
      that = this
      this.getdata(this.params)
      this.getCountryBusiness()
      this.transBusinessList()
      this.getCountryList()
    },
    methods: {
      getCountryBusiness() {
        getCountryBusiness().then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.country_business = res.datas;
          }
        }).catch(err => {
          this.$message.error('Failed to obtain business list, please try again later!')
        })
      },
      cascaderChange(value) {
        var cascader = cascaderChange(value)
        this.params.country = cascader[0]
        this.params.business_name = cascader[1]
      },
      getCountryList() {
        countryList().then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.countryList = res.datas
          }
        }).catch(err => {
          this.$message.error('Failed to get country, please try again later!')
        })
      },
      transBusinessList() {
        transBusinessList().then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            var business_list = res.datas.list;
            business_list.push({
              "id": 0,
              "name": "system number"
            }, {
              "id": 0,
              "name": "hide number"
            });
            this.business_list = business_list
          }
        }).catch(err => {
          this.$message.error('Failed to obtain business list, please try again later!')
        })
      },
      messageCallback(row) {
        this.messageInfo = row
        this.callbackVisible = true
      },
      callbackSubmit() {
        this.loading = true
        messageCallback({
          id: this.messageInfo.id,
        }).then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.callbackVisible = false
            this.getdata(this.params)
            this.$message({
              type: 'success',
              message: 'Send callback successfully'
            })
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed to send callback, please try again later!')
        })
      },
      setFlag(id, flag, flag_business) {
        this.flagVisible = true
        this.editflag.id = id
        this.editflag.flag = flag
        this.editflag.flag_business = flag_business
      },
      exportExcel() {
        window.location.href = exportUrl('/admin/sms/export_sms_backups', this.params);
      },
      // 获取SMS list
      getdata(parameter) {
        if (parameter.trans_time == null) {
          parameter.trans_time = ''
        }
        if (parameter.callback_time == null) {
          parameter.callback_time = ''
        }
        if (parameter.save_time == null) {
          parameter.save_time = ''
        }
        this.loading = true
        smsListNewBackups(parameter).then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.datas.list
            // 分页赋值
            this.pageparm.currentPage = this.params.page
            this.pageparm.pageSize = this.params.limit
            this.pageparm.total = res.datas.count
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed to get SMS list, please try again later!')
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.params.page = parm.currentPage
        this.params.limit = parm.pageSize
        this.getdata(this.params)
      },
      // Search事件
      search() {
        this.params.page = 1
        this.getdata(this.params)
      },
      seeMessage(file_url) {
        window.open(file_url, "_blank");
      },
      closeDialog(type) {
        if (type == 'flag') {
          this.flagVisible = false
        }
        if (type == 'callback') {
          this.callbackVisible = false
        }
        if (type == 'smsAdd') {
          this.smsAddVisible = false
        }
      },
    }
  }

</script>

<style scoped>
  .el-image__error {
    font-size: 12px !important;
  }

  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/views/sms/sms_backups_list.vue